import { pastDueMembersDataset } from '@/lib/member-views/datasets/pastDueMembers.dataset';
import type { PastDueMemberRow } from '@/lib/members/members.types';
import { DaysPastDueCell } from '../cells/DaysPastDueCell';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<PastDueMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  daysPastDue: (row) => <DaysPastDueCell days={row.billingDaysPastDue} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * Past Due: the practice's Active members behind on their membership payment.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function PastDueMembersView() {
  return <MemberViewShell dataset={pastDueMembersDataset} cellOverrides={cellOverrides} />;
}
